export function debounce<T>(func: (this: T, ...args: any) => void, timeout = 300) {
    let timer: NodeJS.Timeout;
    return function (this: T, ...args: any) {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}
